import styled, { css } from 'styled-components';
import { black, grey500 } from 'styles/colors';
import { ApSelect, colors } from '@alixpartners/ui-components';

export const ModalBody = styled.div`
	text-align: center;
	margin: 2px;
`;

export const MetadataSummaryLine = styled.tr``;

export const SummaryLabel = styled.td`
	color: ${grey500};
	font-size: 16px;
	line-height: 32px;
	font-weight: normal;
	padding: 12px 64px 12px 12px;
`;

export const SummaryValue = styled.td`
	color: ${black};
	font-size: 16px;
	font-weight: 500;
	line-height: 32px;
	display: flex;
	align-items: flex-start;
	padding: 8px 0;
	height: 56px;
`;

export const ValueWrapper = styled.div`
	display: inline-flex;
	box-sizing: content-box;
	width: 177px;
	margin-bottom: 19px;
	padding-right: 32px;
`;

export const SelectWrapper = styled.div`
	label {
		display: none;
	}
	& span {
		line-height: 24px;
		border-color: ${colors.grey5};
	}
`;

export const Select = styled(ApSelect)`
	width: 384px;
	min-width: 384px !important;
	${({ small }) =>
		small &&
		css`
			max-width: 175px !important;
			min-width: 175px !important;
		`};
`;

export const DateRangeWrapper = styled.div`
	margin-right: auto;
	margin-top: 0.25%;
	.ap-month-picker > div:nth-child(2) {
		top: 10%;
		right: 50%;
	}
`;
